module.exports = __webpack_public_path__ + "heyground.935a93e4ce658a9c1d85.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/heyground.woff
// module id = 1427
// module chunks = 2